/**
 * PrintOrderSection — Print-only rendering of order line items.
 * Used for combined "Email + Order" printing from EmailViewModal.
 * Hidden on screen, visible only in @media print. Appended to the email
 * print document for "Print Email + Order".
 */
import type { OrderLineItem } from '../../types/orders';
import { ORDER_STATUS_LABELS } from '../../types/orders';
import type { OrderRecord } from '../../types/orders';
import { formatShipToAddress } from '../../utils/orderPrintModel';
import PrintLineItemsTable from './PrintLineItemsTable';
import styles from './PrintOrderSection.module.css';

export interface PrintOrderSectionProps {
  order: OrderRecord;
  lineItems: OrderLineItem[];
}

const PrintOrderSection: React.FC<PrintOrderSectionProps> = ({ order, lineItems }) => (
  <div className={styles.container}>
    <div className={styles.divider}>Order Details</div>
    <div className={styles.orderMeta}>
      <span className={styles.metaItem}>
        <strong>Customer:</strong> {order.customer_name} ({order.customer_no})
      </span>
      <span className={styles.metaItem}>
        <strong>Status:</strong> {ORDER_STATUS_LABELS[order.status]}
      </span>
      {order.po_number && (
        <span className={styles.metaItem}>
          <strong>PO #:</strong> {order.po_number}
        </span>
      )}
      {formatShipToAddress(order.ship_to_address) && (
        <span className={styles.metaItem}>
          <strong>Ship To:</strong> {formatShipToAddress(order.ship_to_address)}
        </span>
      )}
    </div>
    <PrintLineItemsTable lineItems={lineItems} />
  </div>
);

export default PrintOrderSection;
